var map = {
	"./test-q1.png": 2691,
	"./test-q10.png": 5246,
	"./test-q11.png": 9343,
	"./test-q12.png": 4777,
	"./test-q13.png": 7563,
	"./test-q14.png": 4587,
	"./test-q15.png": 982,
	"./test-q16.png": 4728,
	"./test-q2.png": 9236,
	"./test-q3.png": 7925,
	"./test-q4.png": 224,
	"./test-q5.png": 2373,
	"./test-q6.png": 8714,
	"./test-q7.png": 9242,
	"./test-q8.png": 4309,
	"./test-q9.png": 4468
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9204;